export * from './types';
export const stringToObject = <T>(str?: string | null): T => {
  try {
    const stringData = str?.replace(/\s/g, ' ').match(/\{(.*)\}/);
    return JSON.parse(stringData?.[0] || '');
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw Error(message);
  }
};

export const stringToArray = <T>(str?: string | null): T => {
  try {
    const stringData = str?.replace(/\s/g, ' ').match(/\[(.*)\]/);
    return JSON.parse(stringData?.[0] || '');
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw Error(message);
  }
};
